import PropTypes from 'prop-types';
import StyledComponent from '~/components/Styled/Styled';
import css from '~/components/FootballTeamPossession/FootballTeamPossession.scss';

const FootballTeamPossession = ({ fillColor = '#0078fd', style }) => (
  <svg
    className={css.footballTeamPossession}
    fill={fillColor}
    style={{ aspectRatio: '20/12', ...style }}
    viewBox="0 0 20 12"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Football icon marking team possession</title>
    <path
      d="M0 6C0 8.48538 4.477 12 10 12C15.5225 12 20 8.48538 20 6C20 3.51462 15.5225 0 10 0C4.477 0 0 3.51462 0 6ZM12.9995 7.84615C12.9995 8.10092 12.776 8.30769 12.4995 8.30769C12.2235 8.30769 11.9995 8.10092 11.9995 7.84615V6.46154H10.4995V7.84615C10.4995 8.10092 10.276 8.30769 9.9995 8.30769C9.7235 8.30769 9.4995 8.10092 9.4995 7.84615V6.46154H7.9995V7.84615C7.9995 8.10092 7.776 8.30769 7.4995 8.30769C7.2235 8.30769 6.9995 8.10092 6.9995 7.84615V4.15385C6.9995 3.89908 7.2235 3.69231 7.4995 3.69231C7.776 3.69231 7.9995 3.89908 7.9995 4.15385V5.53846H9.4995V4.15385C9.4995 3.89908 9.7235 3.69231 9.9995 3.69231C10.276 3.69231 10.4995 3.89908 10.4995 4.15385V5.53846H11.9995V4.15385C11.9995 3.89908 12.2235 3.69231 12.4995 3.69231C12.776 3.69231 12.9995 3.89908 12.9995 4.15385V7.84615Z"
      fill={fillColor}
    />
  </svg>
);

FootballTeamPossession.displayName = 'FootballTeamPossession';
FootballTeamPossession.defaultProps = {
  fillColor: PropTypes.string,
  style: PropTypes.object,
};

FootballTeamPossession.propTypes = {
  fillColor: '#0078fd',
  style: {},
};

export default StyledComponent(FootballTeamPossession, [css]);
